<template>
  <v-row>
    <div class="col-md-12 home-box">
      <!-- Breadcrumbs -->
      <Breadcrumbs :title="'Stock Report'"></Breadcrumbs>

      <div class="mx-10 ma-5">
        <v-card flat class="pa-5">
          <!-- Page Title + Search + Button -->
          <PageTitleWithSearch
            :title="'Stock Report'"
            :btnName="'Stock Adjustment'"
            :btnColor="'#00B3FF'"
            :btnRoute="'/stock-adjustment'"
            :btnPermission="'stock.create'"
            :btnEnable="true"
            :loading="loading"
            :search="search"
            @searchText="searchChange"
          />

          <!-- Filters -->
          <v-row>
            <v-col cols="12" md="2">
              <v-autocomplete
                v-model="localFilters.branch"
                :items="branches"
                item-text="code"
                item-value="id"
                label="Branch"
                clearable
                dense
                outlined
                @change="emitFilters()"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-autocomplete
                v-model="localFilters.store"
                :items="stores"
                item-text="store_code"
                item-value="id"
                label="Store"
                clearable
                dense
                outlined
                @change="emitFilters()"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-autocomplete
                v-model="localFilters.product"
                :items="products"
                item-text="name"
                item-value="id"
                label="Product"
                clearable
                dense
                outlined
                @change="emitFilters()"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-autocomplete
                v-model="localFilters.batch"
                :items="batches"
                item-text="batch_code"
                item-value="id"
                label="Batch"
                clearable
                dense
                outlined
                @change="emitFilters()"
              />
            </v-col>
            <!-- <v-col cols="12" md="2">
              <v-btn color="primary" @click="emitFilters" :disabled="loading">
                Filter
              </v-btn>
            </v-col> -->
          </v-row>

          <!-- Stock Data Table -->
          <DataTableWithPagination
            :headers="headers"
            :items="stockData"
            :loading="loading"
            :page="page"
            :total="total"
            @pageChange="page = $event"
          >
            <template #row="{ item, index }">
              <tr :key="item.id || index">
                <td>{{ item.stock_number }}</td>
                <td>{{ item.product_name }}</td>
                <td>{{ item.product_code }}</td>
                <td>{{ item.batch_code }}</td>
                <td>{{ item.branch_code }}</td>
                <td>{{ item.store_code }}</td>
                <td class="text-right stk">
                  {{ item.stock_in_hand_quantity }}
                </td>
              </tr>
            </template>
          </DataTableWithPagination>
        </v-card>
      </div>
    </div>
  </v-row>
</template>

<script>
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import { StockReportService } from "@/services/stockReport-service.js";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";

export default {
  name: "StockReport",
  components: { PageTitleWithSearch, Breadcrumbs, DataTableWithPagination },
  data() {
    return {
      loading: false,
      search: "",
      stockData: [],
      branches: [],
      stores: [],
      products: [],
      batches: [],
      headers: [
        { text: "Stock Number", value: "stock_number" },
        { text: "Product Name", value: "product_name" },
        { text: "Product Code", value: "product_code" },
        { text: "Batch Code", value: "batch_id" },
        { text: "Branch Code", value: "branch_code" },
        { text: "Store Code", value: "store_code" },
        {
          text: "Stock In Hand",
          value: "stock_in_hand_quantity",
          align: "center",
        },
      ],
      filters: {
        branch: null,
        store: null,
        product: null,
        batch: null,
      },
      localFilters: {
        branch: null,
        store: null,
        product: null,
        batch: null,
      },
      page: 1,
      total: 0,
    };
  },
  watch: {
    page() {
      this.fetchStockReport();
    },
  },
  created() {
    this.fetchFilters();
    this.fetchStockReport();
  },
  methods: {
    async fetchFilters() {
      this.loading = true;
      try {
        const [
          branchesRes,
          storesRes,
          productsRes,
          batchesRes,
        ] = await Promise.all([
          StockReportService.getBranches(),
          StockReportService.getStores(),
          StockReportService.getProducts(),
          StockReportService.getBatches(),
        ]);

        this.branches = branchesRes.data;
        this.stores = storesRes.data;
        this.products = productsRes.data;
        this.batches = batchesRes.data;
      } catch (error) {
        console.error("Error fetching filters:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchStockReport() {
      this.loading = true;
      try {
        const response = await StockReportService.getStockReport(
          this.filters,
          this.search,
          this.page
        );
        this.stockData = response.data.data || response.data || [];
        this.total = response.data?.meta?.last_page || 0;
      } catch (error) {
        console.error("Error fetching stock report:", error);
        this.stockData = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // Apply filter button click
    emitFilters() {
      this.filters = { ...this.localFilters };
      this.fetchStockReport();
    },

    // Search input change
    searchChange(search) {
      this.search = search;
      this.fetchStockReport();
    },
  },
};
</script>
<style scoped>
.stk {
  padding-right: 163px !important;
}
</style>
